<template>
    <div v-if="selectedFilters.length">
        <div class="selected_title">
            {{ $t('selected_filters') }}
        </div>
        <div v-for="item in selectedFilters" :key="item.key" class="mt-1">
            <div class="d-flex flex-wrap">
                <div class="mr-1 text-body-2">
                    {{ $t(`filterTitles.${item.key}`) }}
                    :
                </div>
                <v-chip
                    v-for="value in item.values"
                    :key="value"
                    color="primary"
                    closable
                    size="small"
                    @click:close="deleteFilter(item.key, value)"
                >
                    {{ item.translatable ? $t(`filters_${item.key}.${value}`) : value }}
                </v-chip>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Emit} from 'vue-facing-decorator'

    @Component
    export class SelectedFilters extends Vue {
        @Prop({default: () => ({})}) selected
        @Prop({default: () => []}) translatable

        @Emit()
        deleteFilter(key, value) {
            return {key, value}
        }

        get selectedFilters() {
            const result = []
            const hidden = [
                'price',
                'loyaltyAmount',
                'name',
                'tourName',
                'shortDescription',
                'duration',
                'startTime',
                'endTime',
                'flightNumber',
                'doorCount',
                'passengerQuantity',
                'baggageQuantity',
                'nightsDuration',
                'isSameAirport',
            ]
            for (let [key, values] of Object.entries(this.selected)) {
                if (!hidden.includes(key) && values.length > 0) {
                    const index = this.translatable.indexOf(key)
                    result.push({key, values, translatable: index >= 0})
                }
            }
            return result
        }
    }

    export default SelectedFilters
</script>
